import { Route, Router, Switch, Redirect } from "react-router-dom";
import React, { useEffect } from "react";
import {
  Budget,
  BudgetForm,
  Admin,
  ProaForm,
  Proa,
  NotFound,
  NotAuthorized,
  UnderConstruction,
  PostLogin,
  Logout,
  Example,
  AdminFollowup,
  UserHelp,
  ProyectaDocuments,
  ProaBeneficiaries,
  Followup,
  FollowByProject,
  FollowByCountry,
  FollowupSubproject,
  AdminPop
} from "../containers";
import Login from "../containers/auth/login";
import { AuthPresenter } from "../presenters/containers/auth.presenter";
import HelpVisor from "../containers/help/HelpVisor";

const RootRouter = () => {
  const presenter = new AuthPresenter();
  useEffect(() => {
    presenter.validateLogin();
  }, []);

  return (
    <Router history={presenter.history}>
      <Switch>
        <Redirect exact from="/" to="/proyecta/presupuesto" />
        <Redirect exact from="/proyecta" to="/proyecta/presupuesto" />
        <Route exact path="/proyecta/login" component={Login}></Route>
        <Route exact path="/proyecta/post_login" component={PostLogin}></Route>
        <Route exact path="/proyecta/logout" component={Logout}></Route>
        <Route exact path="/admin" component={Admin}></Route>
        <Route exact path="/proyecta/presupuesto" component={Budget}></Route>
        <Route exact path="/proyecta/user_help" component={UserHelp}></Route>
        <Route exact path="/proyecta/user_help/:docs" component={HelpVisor}/>
        <Route path="/proyecta/presupuesto/new" component={BudgetForm}></Route>
        <Route path="/proyecta/presupuesto/edit" component={BudgetForm}></Route>
        <Route path="/proyecta/presupuesto/view" component={BudgetForm}></Route>
        <Route exact path="/proyecta/proa" component={Proa}></Route>
        <Route path="/proyecta/proa/view" component={ProaForm}></Route>
        <Route path="/proyecta/proa/edit" component={ProaForm}></Route>
        <Route path="/proyecta/proa/beneficiaries/view" component={ProaBeneficiaries}></Route>
        <Route path="/proyecta/proa/beneficiaries/edit" component={ProaBeneficiaries}></Route>
        <Route path="/proyecta/documentos" component={ProyectaDocuments}></Route>
        <Route exact path="/proyecta/followupAdmin" component={AdminFollowup}></Route>
        <Route exact path="/proyecta/followup" component={Followup}></Route>
        <Route path="/followup/subproject/:screen" component={FollowupSubproject}></Route>
        <Route path="/followup/overlaps/project/:screen" component={FollowByProject}></Route>
        <Route path="/followup/overlaps/country/:screen" component={FollowByCountry}></Route>
        <Route exact path="/proyecta/popAdmin" component={AdminPop}></Route>
        <Route path="/example_test" component={Example}></Route>
        <Route component={NotFound}></Route>
        <Route path="/under-construction" component={UnderConstruction}></Route>
        <Route component={NotAuthorized}></Route>
      </Switch>
    </Router>
  );
};

export default RootRouter;
